/** Mirrors stored Repository.cycleTimeConfig (bot list for PR enrichment). */

export const DEFAULT_REPO_CYCLE_CONFIG = {
  botLogins: [],
};

/**
 * @param {unknown} raw - repository.cycleTimeConfig from API (may be null)
 * @returns {{ botLogins: string[] }}
 */
export function mergeRepoCycleConfigForForm(raw) {
  const base = { botLogins: [...DEFAULT_REPO_CYCLE_CONFIG.botLogins] };
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return base;
  }
  if (Array.isArray(raw.botLogins)) {
    base.botLogins = raw.botLogins.map((s) => String(s).trim()).filter(Boolean);
  }
  return base;
}

/**
 * @param {string} text
 * @returns {string[]}
 */
export function parseBotLoginsText(text) {
  if (!text || typeof text !== 'string') return [];
  return text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
}

/**
 * @param {{ botLogins: string[] }} form
 * @returns {{ botLogins: string[] }}
 */
export function buildCycleTimeConfigPayload(form) {
  const merged = mergeRepoCycleConfigForForm({ botLogins: form.botLogins });
  return { botLogins: merged.botLogins };
}
